import { render, staticRenderFns } from "./SwitchArchiveTables.vue?vue&type=template&id=87fbe95a&scoped=true&"
import script from "./SwitchArchiveTables.vue?vue&type=script&lang=js&"
export * from "./SwitchArchiveTables.vue?vue&type=script&lang=js&"
import style0 from "./SwitchArchiveTables.vue?vue&type=style&index=0&id=87fbe95a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fbe95a",
  null
  
)

export default component.exports